import { render, staticRenderFns } from "./modularChild12.vue?vue&type=template&id=4f8f0adc&scoped=true"
import script from "./modularChild12.vue?vue&type=script&lang=js"
export * from "./modularChild12.vue?vue&type=script&lang=js"
import style0 from "./modularChild12.vue?vue&type=style&index=0&id=4f8f0adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8f0adc",
  null
  
)

export default component.exports